
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.664 8.94L10.691.765a1.02 1.02 0 00-1.382 0L.336 8.941c-.316.287-.42.73-.266 1.128.154.398.53.655.957.655H2.46v8.193c0 .324.263.588.588.588h4.919a.588.588 0 00.588-.588v-4.974h2.89v4.974c0 .324.264.588.589.588h4.918a.588.588 0 00.588-.588v-8.193h1.434c.426 0 .802-.257.956-.655a1.02 1.02 0 00-.266-1.128zM17.387 1.669h-3.95l4.538 4.126V2.257a.588.588 0 00-.588-.588z"}})])
          )
        }
      }
    